import Modal from "../../../Components/Modal/Modal";
import Select from "../../../Components/Select/Select";
import SmallCard from "../../../Components/SmallCard/SmallCard";
import avatar from "../../../images/Avatar_2.svg"
export default function AddUlRepresentingFlModal({ isModal, setModal, flSubject, ulSubjectId,setUlSubjectId, ulSubjectList,onSave}) {
    return (
        <Modal onSave={onSave} isOpen={isModal} setOpen={setModal} title="Добавление ЮЛ как представитель ФЛ">
            <label>Физ лицо</label>
            <SmallCard
                title={`${flSubject?.Lastname} ${flSubject?.Firstname} ${flSubject?.Middlename}`}
                subtitle={`СНИЛС: ${flSubject?.Snils}`}
                avatar={avatar}
            />
            <Select value={ulSubjectId} onChange={(value)=>setUlSubjectId(value)} label="ЮЛ представитель">
                {ulSubjectList.map((x) =>
                    <option value={x.Id}>{x.Name}</option>
                )}
            </Select>

        </Modal>)
}